import * as http from '../http'
import * as Types from './types'

export default class ExtraCampaignGateway {
  getAlternativeCampaign (params = {}) {
    return http.GET(Types.GET_ALTERNATIVE_CAMPAIGN, params)
  }

  alternativeCampaignAddEmail (query = {}) {
    return http.POST(Types.CAMPAIGN_ADD_EMAIL, query)
  }

  getUnassignedAlternativeCampaign (params = {}) {
    return http.GET(Types.UNASSIGNED_ALTERNATIVE_CAMPAIGN, params)
  }

  getAlternativeEmailsHistory (params = {}) {
    return http.GET(Types.ALTERNATIVE_HISTORY_EMAILS, params)
  }

  updateExtraCurrentEmailTemplate (query = {}) {
    return http.POST(Types.UPDATE_CURRENT_EMAIL_TEMPLATE, query)
  }

  getExtraCurrentEmailTemplate (params = {}) {
    return http.GET(Types.GET_CURRENT_EMAIL_TEMPLATE, params)
  }

  getAlternativeIndividualEmails (params = {}) {
    return http.GET(Types.ALTERNATIVE_INDIVIDUAL_LISTS, params)
  }

  allAlternativeCampaigns () {
    return http.GET(Types.ALL_ALTERNATIVE_CAMPAIGNS)
  }

  allowedNamesAlternativeCampaigns () {
    return http.GET(Types.GET_NAMES_ALTERNATIVE_CAMPAIGN)
  }

  createAlternativeCampaign (query = {}) {
    return http.POST(Types.CREATE_ALTERNATIVE_CAMPAIGN, query)
  }

  closeAlternativeCampaign (query = {}) {
    return http.POST(Types.CLOSE_ALTERNATIVE_CAMPAIGN, query)
  }

  sendEmailsAlternativeCampaign (query = {}) {
    return http.POST(Types.SEND_EMAILS_ALTERNATIVE_CAMPAIGN, query)
  }

  codesResetAlternativeCampaign (query = {}) {
    return http.POST(Types.CODE_RESET_ALTERNATIVE_CAMPAIGN, query)
  }

  resetManyAlternativeCampaign (query = {}) {
    return http.POST(Types.RESET_MANY_ALTERNATIVE_CAMPAIGN, query)
  }

  codesDeleteAlternativeCampaign (query = {}) {
    return http.DELETE(Types.CODE_DELETE_ALTERNATIVE_CAMPAIGN, {}, query)
  }

  deleteManyAlternativeCampaign (query = {}) {
    return http.DELETE(Types.DELETE_MANY_ALTERNATIVE_CAMPAIGN, {}, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/ExtraCampaignGateway.js